import { CloseCircleOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { ButtonColorType, ButtonVariantType } from 'antd/es/button';
import type { SizeType } from 'antd/es/config-provider/SizeContext';

type TCloseButton = {
  loading: boolean;
  className?: string;
  disabled: boolean;
  icon?: React.ReactNode;
  onClick?: () => void;
  size?: SizeType;
  variant?: ButtonVariantType;
  color?: ButtonColorType;
};

export const CloseButton: React.FC<TCloseButton> = (props) => {
  const { t } = useTranslation();

  const {
    loading,
    className,
    disabled,
    icon = <CloseCircleOutlined />,
    onClick,
    variant = 'outlined',
    size = 'small',
    color = 'default',
  } = props;

  return (
    <Button
      key={'close'}
      size={size}
      variant={variant}
      className={className}
      disabled={disabled}
      icon={icon}
      color={color}
      loading={loading}
      onClick={onClick}
    >
      {t('actions.close')}
    </Button>
  );
};
